import React from 'react';
import { connectToStore } from '../../../store';
import styles from './ClientDetails.module.scss';

function ClientDetails() {
	return <div className={styles.clientDetails}>Client Details - Work in Progress</div>;
}

export default connectToStore(ClientDetails);
